import React from 'react'
import Modal from 'react-modal';

Modal.setAppElement('#root');
const ModalForm = (props) => {

    const { show, onClose } = props

    return (
        <Modal
            isOpen={show}
            contentLabel=""
            className="modal-content"
            overlayClassName="modal-overlay"
            onRequestClose={onClose}>
            <div className="p-1 p-md-2">
                {props.children}
            </div>
        </Modal>
    );
}

export default ModalForm;